// Mientras el play espera a que lleguen datos del video — ADR-2026-11-03-el-play-sigue-al-video.
//
// El reloj ahora espera al video en vez de seguir de largo; sin esto, con red
// lenta el preview parecería trabado.
import { Loader2 } from 'lucide-react';
import { useAperturaAnimada } from '../../hooks/useAperturaAnimada';

export function CargandoElVideo({ esperando }: { esperando: boolean }) {
  const { montado, visible } = useAperturaAnimada(esperando, 150);
  if (!montado) return null;
  return (
    <div
      role="status"
      className={`pointer-events-none absolute right-2 top-2 z-[60] flex items-center gap-1.5 rounded-md bg-black/60 px-2.5 py-1.5 text-[11.5px] font-medium text-white transition-[opacity,transform,filter] ease-out ${
        visible
          ? 'opacity-100 duration-300 motion-safe:translate-y-0 motion-safe:blur-0'
          : esperando
            ? 'opacity-0 duration-300 motion-safe:translate-y-3 motion-safe:blur-[4px]'
            : 'opacity-0 duration-150 motion-safe:-translate-y-3 motion-safe:blur-[4px]'
      }`}
    >
      <Loader2 className="h-3.5 w-3.5 animate-spin" aria-hidden="true" />
      Cargando el video…
    </div>
  );
}
